import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, ButtonAnchor } from 'modules/styled/web';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { loginUser } from 'modules/auth/auth.actions';
import { withRouter } from 'react-router-dom';
import { showModal } from 'modules/navigation/navigation.actions';
import ReduxFormField from 'modules/styled/form/reduxformfield.component';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { required } from 'modules/form/validators';
import BoxLogin from 'modules/auth/web/login.web3';
import { View, LinkFont, Image, TextButton } from 'modules/styled';

const twitterIcon = require('public/img/icons/twitter_white.png');
// const redditIcon = require('public/img/icons/reddit.png');

class LoginForm extends Component {
  static propTypes = {
    location: PropTypes.object,
    auth: PropTypes.object,
    actions: PropTypes.object,
    close: PropTypes.func,
    handleSubmit: PropTypes.func,
    username: PropTypes.string,
    password: PropTypes.string,
  };

  login = async (data) => {
    try {
      const user = {
        name: data.username,
        password: data.password,
      };
      const loggedIn = await this.props.actions.loginUser(user);
      if (loggedIn) {
        this.props.close();
      }
    } catch (err) {
      // TODO error handling
    }
  };

  render() {
    const { location, handleSubmit, username, password } = this.props;
    const { invitecode } = this.props.auth;
    const local = username && username.length && password && password.length;
    let { redirect } = queryString.parse(location.search);
    if (!redirect) redirect = location.pathname;

    const FORM_FIELDS = [
      {
        label: 'Username or email',
        component: ReduxFormField,
        name: 'username',
        autocomplete: 'username',
        type: 'text',
        validate: [required],
      },
      {
        type: 'password',
        component: ReduxFormField,
        label: 'Password',
        name: 'password',
        autocomplete: 'current-password',
        validate: [required],
      },
    ];

    const socialSignup = (
      <LinkFont sx={{ flexShrink: 1, mt: [4, 0] }}>
        Not registered yet?{' '}
        <TextButton
          type="button"
          onClick={() => {
            this.props.actions.showModal('signupSocial');
          }}
        >
          Sign up
        </TextButton>
      </LinkFont>
    );

    return (
      <Form sx={{ flexDirection: 'column' }} onSubmit={handleSubmit(this.login)}>
        {FORM_FIELDS.map((field) => (
          <Field {...field} key={field.name} />
        ))}
        <View sx={{ mt: 1, alignItems: 'flex-start', justifyContent: 'flex-start' }}>
          <TextButton
            type="button"
            onClick={() => {
              this.props.actions.showModal('forgot');
            }}
          >
            <LinkFont sx={{ color: 'blue' }}>Forgot Your Password?</LinkFont>
          </TextButton>
        </View>

        <View>
          {local ? (
            <View
              sx={{
                flex: 1,
                width: '100%',
                flexDirection: ['column', 'row'],
                alignItems: ['stretch', 'center'],
                mt: 4,
              }}
            >
              <Button type="submit" sx={{ mr: [0, 2] }}>
                Sign In
              </Button>
              {socialSignup}
            </View>
          ) : null}
        </View>

        <View>
          {!local ? (
            <View
              sx={{
                flexDirection: ['column', 'row'],
                alignItems: ['stretch', 'center'],
                mt: [4, 3],
              }}
            >
              <ButtonAnchor
                rel="nofollow"
                href={`/auth/twitter?redirect=${redirect}${
                  invitecode ? `&invitecode=${invitecode}` : ''
                }`}
                sx={{ bg: 'twitterBlue', mr: [0, 2], mt: [2, 0] }}
              >
                <Image
                  source={twitterIcon}
                  sx={{ width: 4, height: 4, mr: 1.5 * 8.0001 }}
                />
                <LinkFont sx={{ color: 'white' }}>Sign In with Twitter</LinkFont>
              </ButtonAnchor>
              <View sx={{ mt: [2, 0] }} />
              <BoxLogin close={this.props.close} />
              {socialSignup}
            </View>
          ) : null}
        </View>
      </Form>
    );
  }
}

const selector = formValueSelector('login');

const mapStateToProps = (state) => ({
  user: state.auth.user,
  auth: state.auth,
  ...selector(state, 'username', 'password'),
  initialValues: {},
  enableReinitialize: true,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      loginUser,
      showModal,
    },
    dispatch
  ),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: 'login',
    })(LoginForm)
  )
);
